import { render, staticRenderFns } from "./subTable.vue?vue&type=template&id=45e54605&"
import script from "./subTable.vue?vue&type=script&lang=js&"
export * from "./subTable.vue?vue&type=script&lang=js&"
import style0 from "./subTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports